import React, { useEffect, useState, useRef, useCallback } from "react";
import { createRoot } from '@wordpress/element';
import { ConnectionContext, getConnectionInfo, getEndpoint, getMatchURL } from './utils';
import { getStoredData } from "./utils/data-pulls";
import { LiveBtn } from "./components/liveBtn";




const LiveTickerApp = (props) => {
    const { 
        ...restProps 
    } = props;

    // Error and load handling
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    // Connection Information
    const [connectionInfo, setConnectionInfo] = useState(null);

    const [ activeUIDs, setActiveUIDs ] = useState(null);
    const [ matches, setMatches ] = useState(null);



    /**
     * Get our connection info and list of active UIDs
     */
    useEffect(() => {

        // Get our connection info
        getConnectionInfo().then(
            (result) => {
                setConnectionInfo(result.data);
            }
        ).catch(
            (error) => {
                setError(error);
            }
        );

        // Get active UIDs list
        let args = [
            {
                key: 'activeUIDs'
            }
        ];
        getStoredData(args).then(
            (result) => {

                // Set Active UIDs
                if ( result.data.activeUIDs ) {
                    setActiveUIDs(result.data.activeUIDs);
                }

            }
        ).catch(
            (error) => {
                setError(error);
            }
        );

    }, []);


    /**
     * Get live game list, and refresh based on refreshCounter
     */
    useEffect(() => {
        if ( !connectionInfo || !activeUIDs ) return;

        const liveEndpoint = getEndpoint('match_list_live', {
            tenant: connectionInfo.tenant
        }, {
            organizationIdFilter: connectionInfo.organization_id
        }, connectionInfo.environment);
        
        fetch(liveEndpoint, {
            method: 'GET',
            headers: {
                'API_KEY': connectionInfo.api_key
            },
        })
          .then(res => res.json())
          .then(
            (result) => {
                if ( !result ) {
                    setMatches(null);
                    return;
                }
                
                const numberToShow = 10;
                if ( !result || result.length == 0 ) {
                  setMatches(null);
                } else {

                    /**
                     * API will return results for each province. 
                     * Use the list of activeUIDs entered on the website to filter only to live matches we want to view
                     */
                    let validMatches = [];
                    result.forEach((match, i) => {
                        const exists = activeUIDs.includes(match.competition.id);
                        if ( exists ) {
                            validMatches.push(match);
                        }
                    });
                    
                    if ( validMatches.length == 0 ) {
                        setMatches(null);
                    } else if ( validMatches.length <= numberToShow ) {
                        setMatches(validMatches);
                    } else {
                        setMatches(validMatches.slice(0, numberToShow));
                    }

                } 

                setIsLoaded(true);
            },
            (error) => {
              setIsLoaded(true);
              setError(error);
              console.log(error);
            }
          );

    }, [connectionInfo, activeUIDs]);



    // Bail if we don't have data yet
    if (!isLoaded ) {
        return;
    }

    return (
        <ConnectionContext.Provider value={connectionInfo}>
            { matches ? 
                matches.length > 1 ? 
                    ( 
                        <div className="acaTicker acaTicker--multiple">
                            <div className="acaTicker__header">
                                <LiveBtn />
                                <button className="acaTicker__title">{matches.length} Matches Ongoing</button>
                            </div>
                            <ul className="acaTicker__dropdown">
                                { matches.map((match, i) => (
                                    <li key={i} className="acaTickerMatch">
                                        <a href={getMatchURL(match.id)} className="acaTickerMatch__link">
                                            <span className="acaTickerMatch__score">
                                                { match.hasOwnProperty('homeTeamResult') ? match.homeTeamResult.current : '' }
                                            </span>
                                            <span className="acaTickerMatch__desc">
                                                { match.homeTeam.name } vs { match.awayTeam.name }
                                            </span>
                                            <span className="acaTickerMatch__score">
                                                { match.hasOwnProperty('awayTeamResult') ? match.awayTeamResult.current : '' }
                                            </span>
                                        </a>
                                    </li>
                                ) ) }
                            </ul>
                        </div>
                    ) 
                    : (
                        <div className="acaTicker acaTicker--single">
                            <div className="acaTicker__header">
                                <LiveBtn />
                                { matches.map((match, i) => (
                                    <div key={i} className="acaTickerMatch">
                                        <a href={getMatchURL(match.id)} className="acaTickerMatch__link">
                                            <span className="acaTickerMatch__score">
                                                { match.hasOwnProperty('homeTeamResult') ? match.homeTeamResult.current : '' }
                                            </span>
                                            <span className="acaTickerMatch__desc">
                                                { match.homeTeam.name } vs { match.awayTeam.name }
                                            </span>
                                            <span className="acaTickerMatch__score">
                                                { match.hasOwnProperty('awayTeamResult') ? match.awayTeamResult.current : '' }
                                            </span>
                                        </a>
                                    </div>
                                ) ) }
                            </div>
                        </div>
                    ) 
                : (
                    <div className="acaTicker acaTicker--none">
                        <a href={typeof acaScheduleURL !== 'undefined' ? acaScheduleURL : '#'} className="acaBtn acaBtn--small acaBtn--solid acaBtn--blue">See upcoming matches</a>
                    </div>
                )
            }
        </ConnectionContext.Provider>
    );
}

export default LiveTickerApp;

// Render Match Page
const appContainer = document.getElementById('liveTickerApp');
const root = createRoot(appContainer);
root.render(<LiveTickerApp />);



